<template>
  <div class="centerx">
      <!-- redeploy access token -->
    <vs-popup fullscreen title="SIMULACIÓN DE CRÉDITO" :active.sync="isDSActive">
      <vx-card title="Simulación" v-if="down">

        <div slot="no-body" class="pr-6 pl-6 pb-base">
          <p class="text-subtitle mt-2 mt-2">Ahorros proyectados para fines informativos. Cálculos generados en función
            de cotización, consumo y precios actuales de electricidad. Condiciones de crédito sujetas a aprobación.</p>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex flex-wrap">
                <vs-button class="ml-auto" @click="download()">Descargar</vs-button>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="title">Información de cotización.</div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">

              <!-- resumen del credito -->
              <table class="table-row full-border">
                <tr class="vertical-top">
                  <!-- COL 1-->
                  <td class="w-50 p-l">
                    <table class="table-row-spaced">
                      <tbody>
                      <tr class="info-row">
                        <td class="irl bold">Título de simulación</td>
                        <td class="irv">{{ name_cot != '' ? name_cot : '-' }}</td>
                      </tr>
                      </tbody>
                    </table>
                    <table class="table-row-spaced">
                      <tbody>
                      <tr class="info-row">
                        <td class="irl bold">Costo del sistema</td>
                        <td class="irv">{{ formatPrice(data_.total_cost) }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </td>

                  <!-- COL 2-->
                  <td class="w-50 p-r">
                    <!-- FREE SPACE -->
                  </td>
                </tr>
              </table>
              <!-- fin resumen del credito -->
            </div>
          </div>

          <div class="vx-row mt-4">
            <div class="vx-col w-full">

              <!-- resumen del credito -->
              <table class="table-row full-border" v-if="finance !== null">
                <tr class="vertical-top">
                  <!-- COL 1-->
                  <td class="w-50 p-l">
                    <div class="title">El resumen de tu crédito.</div>
                    <table class="table-row-spaced">
                      <tbody>
                      <tr class="info-row">
                        <td class="irl bold">Costo del Sistema - Enganche</td>
                        <td class="irv">${{ formatPrice(finance.total_cost - finance.initial_payment ) }}</td>
                      </tr>
                      <tr class="info-row shaded">
                        <td class="irl bold">+ Comisión Administrativa</td>
                        <td class="irv">${{ formatPrice(finance.ensurance) }}</td>
                      </tr>
                      <tr class="info-row shaded">
                        <td class="irl bold">+ Comisión por Fondeo</td>
                        <td class="irv">${{ formatPrice(finance.admon_comission) }}</td>
                      </tr>
                      <tr class="info-row shaded">
                        <td class="irl bold">+ Interesés Financiados</td>
                        <td class="irv">${{ formatPrice(finance.financed_interests) }}</td>
                      </tr>
                      <tr class="info-row dark">
                        <td class="irl bold">= Monto a financiar</td>
                        <td class="irv">${{ formatPrice(finance.financed_amount) }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </td>

                  <!-- COL 2-->
                  <td class="w-50 p-r">
                    <div class="title">Tus pagos.</div>
                    <table class="table-row-spaced">
                      <tbody>
                      <tr class="info-row">
                        <td class="irl bold">Comisión por Apertura</td>
                        <td class="irv">${{ formatPrice(finance.openning_comission) }}</td>
                      </tr>
                      <tr class="info-row">
                        <td class="irl bold">+ Enganche</td>
                        <td class="irv">${{ formatPrice(finance.deposit) }}</td>
                      </tr>
                      <!--<tr class="info-row dark">
                        <td class="irl bold">= Pago Inicial <span v-if="finance.delivery_term > 0">(1 Pago)</span></td>
                        <td class="irv">${{ formatPrice(finance.initial_payment) }}</td>
                      </tr>-->
                      <tr class="info-row high" v-if="finance.delivery_term > 0">
                        <td class="irl bold">Pago Entrega ({{ finance.delivery_term }} Pagos)</td>
                        <td class="irv">${{ formatPrice(finance.delivery_term_period_payment) }}</td>
                      </tr>
                      <tr class="info-row high">
                        <td class="irl bold">Pago Mensual ({{ finance.term - finance.delivery_term }} Pagos)</td>
                        <td class="irv">${{ formatPrice(finance.monthly_payment) }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </table>
              <!-- fin resumen del credito -->
            </div>
          </div>


          <div class="vx-row mt-4">
            <div class="vx-col w-full">
              <div class="title">Las condiciones de tu crédito.</div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">

              <!-- resumen del credito -->
              <table class="table-row full-border">
                <tr class="vertical-top">
                  <!-- COL 1-->
                  <td class="w-50 p-l">
                    <table class="table-row-spaced">
                      <tbody>
                      <tr class="info-row">
                        <td class="irl bold">Plazo (Meses)</td>
                        <td class="irv">{{ data_.term }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </td>

                  <!-- COL 2-->
                  <td class="w-50 p-r">
                    <table class="table-row-spaced">
                      <tbody>
                      <tr class="info-row">
                        <td class="irl bold">Tasa Anual</td>
                        <td class="irv">{{ data_.annual_interest_percentage }}%</td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </table>
              <!-- fin resumen del credito -->
            </div>
          </div>


          <div class="vx-row mt-6">
            <div class="vx-col w-full">

              <!-- Tabla plan de pagos -->
              <table class="table-dynamic" aria-describedby="pagos">
                <thead>
                <tr class="table-title">
                  <th colspan="8">
                    <div class="title pb-3 text-left">Plan de Pagos.</div>
                  </th>
                </tr>
                <tr class="table-cols">
                  <th>Mes</th>
                  <th>Pago</th>
                  <th>Pago en efectivo</th>
                  <th>Pago Financiado</th>
                  <th>Saldo Inicial</th>
                  <th>Amort. a Capital</th>
                  <th>Interés</th>
                  <th>IVA</th>
                  <th>Com. Bancaria</th>
                  <th>Saldo Final</th>
                </tr>
                </thead>
                <tbody>
                <tr class="f-12" v-for="item in amortization" :key="item.number">
                  <td class="center">{{ item.number }}</td>
                  <td class="center">${{ formatPrice(item.payment) }}</td>
                  <td class="center">${{ formatPrice(item.cash_payment)}}</td>
                  <td class="center">${{ formatPrice(item.payment - item.cash_payment) }}</td>
                  <td class="center">${{ formatPrice(item.initial_debt) }}</td>
                  <td class="center">${{ formatPrice(item.amortization) }}</td>
                  <td class="center">${{ formatPrice(item.interest) }}</td>
                  <td class="center">${{ formatPrice(item.tax) }}</td>
                  <td class="center">${{ formatPrice(item.client_comission) }}</td>
                  <td class="center">${{ formatPrice(finance.financed_amount) }}</td>
                </tr>
                </tbody>
              </table>
              <!-- Fin Tabla plan de pagos -->

            </div>
          </div>
        </div>

      </vx-card>
    </vs-popup>
  </div>
</template>

<script>
import {formatPrice, parseValue, parseFloatValue} from '../../filters.js'

export default {
  name: "detailed-simulator-pop-up",
  props: ["project", "rate"],
  data: function() {
    return {
      my_name: '',
      loading: false,
      amortization: [],
      finance: null,
      down: false,
      data_: {
        total_cost: null,
        term: null,
        deposit_percent: null,
        annual_interest_percentage: null
      },
      complete: true,
      name: "Simulación detallada",
      name_cot: this.project.alias,
      tasa: null
    }
  },
  computed: {
    isDSActive: {
      get() {
        return this.$store.state.isDSActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_DETAILED_SIMULATION_POPUP_ACTIVE", val);
      }
    }
  },
  watch: {
    isDSActive: async function (val) {
      // saber cuando se cierra o se abre el modal para reiniciar los valores
      if (val) {
        await this.simulate();
      } else {
        this.isDSActive = false;
        this.amortization = [];
        this.finance = {};
        this.down = false;
        this.data_ = {
          total_cost: null,
          term: null,
          deposit_percent: null,
          annual_interest_percentage: null
        };
      }
    },
    loading: function () {
      if (this.loading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
  },
  methods: {
    formatPrice,
    parseValue,
    makePayload() {
      let realTotalCost = (this.project.finance.currency === 'usd') ?
          this.project.finance.total_cost_usd : this.project.finance.total_cost;

      return {
        finance_product_id: 1,
        total_cost: realTotalCost,
        term: this.project.finance.term,
        deposit_percentage: this.project.finance.deposit_percentage,
        annual_interest_percentage: this.project.finance.annual_interest_percentage,
        is_photovoltaic: true,
        delivery_term: this.project.finance.delivery_term,
        payment_periodicity: this.project.finance.payment_periodicity,
        currency: this.project.finance.currency,
        loan_type: this.project.finance.loan_type,
        rate: this.rate,
        capital_paid_at_term: this.project.finance.capital_paid_at_term_percentage||0,
        surplus_percentage: this.project.finance.total_cost_surplus_percentage||0,
        financed_interest_percentage: this.project.finance.financed_interests_percentage,
        spread_portfolio: this.project.finance.spread_portfolio ? 1 : 0,
        amortization_type: this.project.finance.amortization_type,
        crowdfunding_loan_type: this.project.finance.crowdfunding_loan_type,
        qualification: this.project.finance.qualification,
        project_category_id: this.project.finance.project_category_id,
        interest_periodicity: this.project.finance.interest_periodicity,
        amortization_periodicity: this.project.finance.amortization_periodicity,
      }
    },
    async simulate() {
      try {
        this.loading = true;
        let response = await axios.post('/api/loan/finance/simulate', this.makePayload())

        this.amortization = response.data.amortization;
        this.finance = response.data.finance;
        this.down = true;
      } catch (e) {
        this.failedOperationNotif("Error generando la simulación");
      }
      this.loading = false;
    },
    async download() {
      let request = this.makePayload();

      const {data} = await axios.post('/api/loan/finance/pdf', request)
      const downloadLink = document.createElement("a");
      downloadLink.href = data.pdf_base64;
      downloadLink.download = this.name !== '' ? 'Simulación ' + this.name_cot + '.pdf' : 'Simulación.pdf'
      downloadLink.click();
    },
  }
};
</script>

<style scoped>

.table-row {
  width: 100%;
  border-collapse: collapse;
  display: table !important;
}

.table-row-spaced {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0px 5px;
}

.w-8 {
  width: 8%;
}

.w-10 {
  width: 10%;
}

.w-12 {
  width: 12%;
}

.w-15 {
  width: 15%;
}

.w-20 {
  width: 20%;
}

.w-25 {
  width: 25%;
}

.w-30 {
  width: 30%;
}

.w-33 {
  width: 33%;
}

.w-34 {
  width: 34%;
}

.w-38 {
  width: 38%;
}

.w-40 {
  width: 40%;
}

.w-45 {
  width: 45%;
}

.w-50 {
  width: 50%;
}

.w-60 {
  width: 60%;
}

.w-65 {
  width: 65%;
}

.w-70 {
  width: 70%;
}

.w-100 {
  width: 100%;
}

.p-l {
  padding-right: 10px;
}

.p-m {
  padding-left: 10px;
  padding-right: 10px;
}

.p-r {
  padding-left: 10px;
}

.pb-5 {
  padding-bottom: 5px;
}

.pb-10 {
  padding-bottom: 10px;
}

.al-l {
  float: left;
}

.al-r {
  float: right;
}

.primary {
  color: #f9a01b;
}

.secondary {
  color: #000;
}


.center {
  text-align: center;
}

.left {
  text-align: left;
}

.right {
  text-align: right;
}

.vertical-top {
  vertical-align: top;
}

.vertical-center {
  vertical-align: middle;
}

.row-space {
  height: 18px;
}

.col-space {
  height: 10px;
}

.word-space {
  height: 5px;
}

.title {
  font-size: 18px;
  font-weight: normal;
  font-family: "gilroybold";
}

.info-row {
  width: 100%;
  font-family: "gilroybold";
  /*  font-size: 12px; */
}

.info-row > td {
  height: 35px;
}

.info-row.high {
  font-weight: bold;
  color: #f9a01b;
}

.info-row.shaded {
  background-color: #ccc;
  color: #000;
}

.info-row.dark {
  background-color: #313131;
  color: #fff;
}

.info-row.colored {
  font-weight: bold;
  background-color: #f9a01b;
  color: #fff;
}

.irl {
  padding-left: 6px;
  text-align: left;
  border-width: 1px 0 1px 0;
  border-style: solid;
  border-color: #e8e8e8;
  border-top-color: transparent;
}

.irv {
  padding-right: 6px;
  text-align: right;
  border-width: 1px 0 1px 0;
  border-style: solid;
  border-color: #e8e8e8;
  border-top-color: transparent;
}

.full-border .irl {
  padding-left: 6px;
  text-align: left;
  border-width: 2px 0 2px 2px;
  border-style: solid;
  border-color: #000;
}

.full-border .irv {
  padding-right: 6px;
  text-align: right;
  border-width: 2px 2px 2px 0;
  border-style: solid;
  border-color: #000;
  border-top-color: #000;
}

.strong .irl {
  border-width: 1px 0 2px 0px;
  border-bottom-color: #000;
}

.strong .irv {
  border-width: 1px 0px 2px 0;
  border-bottom-color: #000;
}

.full-border .strong .irl {
  border-width: 1px 0 2px 1px;
  border-color: #000;
}

.full-border .strong .irv {
  border-width: 1px 1px 2px 0;
  border-color: #000;
}

.high .irl {
  border-width: 2px 0 2px 2px;
  border-color: #f9a01b;
}

.high .irv {
  border-width: 2px 2px 2px 0;
  border-color: #f9a01b;
}

.shaded .irl, .shaded .irv {
  border-color: #ccc;
}

.colored .irl, .colored .irv {
  border-color: #f9a01b;
}

.dark .irl, .dark .irv {
  border-color: #313131;
}

.black {
  color: #000;
}

td.empty {
  font-size: 14px;
  text-align: center;
  background-color: #e8e8e8
}

.table-dynamic {
  width: 100%;
  border-collapse: collapse;
}

.table-dynamic .table-cols {
  background-color: #f9a01b;
  font-weight: normal;
  font-family: 'gilroybold';
  color: #fff;
  text-align: center;
}

.table-dynamic .table-cols th {
  font-weight: bold;
  font-size: 14px;
  height: 30px;
  vertical-align: middle;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}

.table-dynamic .table-cols th:first-child {
  border-left: 1px solid #000;
}

.table-dynamic .table-cols th:last-child {
  border-right: 1px solid #000;
}

.table-dynamic > tbody {
  border: 1px solid #000;
}

.table-dynamic > tbody > tr {
  vertical-align: middle;
}

.table-dynamic > tbody > tr > td {
  border-bottom: 1px solid #000;
  padding-top: 5px;
  padding-bottom: 5px;
}

.table-dynamic.movements > tbody > tr > td {
  border-bottom: 1px solid #ccc;
  padding-top: 3px;
  padding-bottom: 3px;
  font-size: 9px;
}

.table-dynamic.movements tbody tr:last-child td {
  border-bottom: 1px solid #000;
}

.table-dynamic.movements > tbody > tr > td.empty {
  font-size: 14px;
  text-align: center;
  background-color: #e8e8e8
}

.table-dynamic .table-title {
  text-align: left;
}

.v-pad-5 {
  padding: 5px 0;
}

.v-pad-10 {
  padding: 10px 0;
}

.w-qr {
  width: 170px;
}

.h-qr {
  height: 170px;
}

</style>
